// @flow

import { CollectionActionActions } from '../../store/orm/Action';

export const fetchCollectionActions = ({ match }: any, token?: string) =>
  CollectionActionActions.fetchCollectionActions(
    match.params.collectionId,
    token
  );
